// extracted by mini-css-extract-plugin
module.exports = {"breadcrumbLink":"Breadcrumbs_breadcrumbLink__2ZTkl","title":"Breadcrumbs_title__3gIYB","separator":"Breadcrumbs_separator__1OmA_"};